import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MonacoEditorService {

  constructor() { }

  destroyEditors(editors: any[]): void {
    editors?.forEach(editor => {
      if (!editor) {
        return;
      }

      try {
        const model = editor.getModel?.();

        if (model) {
          if ('original' in model && 'modified' in model) {
            model.original?.dispose?.();
            model.modified?.dispose?.();
          }
          else {
            model.dispose?.();
          }
        }

        editor.dispose?.();

      } catch (error) {
        console.warn('Error disposing Monaco editor:', error);
      }
    });
  }
}
